<template>
    <Breadcrumbs :here="'日ごとの集計'"
                 :ancestries="ancestries"/>
    <div class="row">
        <div class="col h2"
             :style="{ fontSize: FontSizes.large2}">日ごとの集計</div>
    </div>
    <div class="row">
        <div class="col">
            <table class="table">
                <thead>
                    <tr>
                        <th>日付</th>
                        <th>前払い申請額（&#9312;）</th>
                        <th>システム利用料（&#9313;）</th>
                        <th>振込手数料（&#9314;）</th>
                        <th>振り込み金額(&#9312; - &#9313; - &#9314;)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="aggr in aggregations"
                        :key="aggr.vForKey">
                        <td>{{ aggr.dateString }}</td>
                        <td>&yen;{{ aggr.amount.toLocaleString() }}</td>
                        <td>&yen;{{ aggr.systemFeeTotal.toLocaleString() }}</td>
                        <td>&yen;{{ aggr.transferFeeTotal.toLocaleString() }}</td>
                        <td>&yen;{{ aggr.transferredAmount.toLocaleString() }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import {PaymentAggregation} from "@/data-models/payment-aggregation";
import {backendApi} from "@/utils/backend-api";
import {subPaths} from "@/utils/consts";
import {useRouter} from "vue-router";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import {FontSizes} from "@/utils/font-sizes";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default defineComponent({
    name: "PaymentAggregation",
    components: {Breadcrumbs},
    setup() {

        const aggregations = ref<PaymentAggregation[]>([] as PaymentAggregation[])

        const router = useRouter()

        onMounted(async () => {
            const resp = await backendApi.inquirePaymentAggregations()
            // console.log(resp)
            if (resp.isAuthorized) {
                aggregations.value = PaymentAggregation.fromJsonArrToArr(resp.value)
                // console.log(aggregations.value)
            } else {
                await router.push(subPaths.LOGIN)
            }

            loadingOverlayStateStore.commit("fadeout")
        })

        return {
            aggregations,
            FontSizes,
            ancestries: [
                {
                    name: "ホーム",
                    pathObj: subPaths.HOME
                }
            ],
        }
    }
})
</script>

<style scoped lang="scss">

</style>